import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({ selector: '[shipmentStatus]' })
export class ShipmentStatusDirective implements OnInit {
  @Input() shipmentStatus: any 
  constructor(private el:ElementRef, private renderer: Renderer2) { 
  }
  ngOnInit(): void {
    switch(this.shipmentStatus){
      case "ARRIVED_AT_LOAD_PORT": this.el.nativeElement.classList.add('badge', 'badge-secondary');break;
      case "VESSEL_SAILED": {
        //this.el.nativeElement.style.backgroundColor = '#f77f00';
        this.el.nativeElement.classList.add('badge', 'badge-primary');
        break;
      }
      case "ARRIVED_AT_DESTINATION":this.el.nativeElement.classList.add('badge', 'badge-success');break;
      case "BERTHED_AT_LOAD_PORT": this.el.nativeElement.classList.add('badge', 'badge-secondary');break;
      default: this.el.nativeElement.classList.add('badge', 'badge-secondary')
    }
    
  }

}
